import React from "react";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function CardHeaderList({ children, className, ...props }: IProps) {
    const classNames = ["userful-card-header-list noselect", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
